import { MagicBoxAnimatedIconGrey } from "../../../magic-box/components/MagicBoxAnimatedIconGrey"
import { VaultInProgressStatusWrapper } from "./VaultStatuses.styles"

export const VaultInProgressStatus = ({ minimized }) => {
    if (minimized) {
        return <MagicBoxAnimatedIconGrey width="16px" margin="0" display="flex" fill="#1A1B1D" />
    }

    return (
        <VaultInProgressStatusWrapper>
            <MagicBoxAnimatedIconGrey width="16px" margin="0" display="flex" fill="#1A1B1D" />
            <div>In progress</div>
        </VaultInProgressStatusWrapper>
    )
}